/**
 * @deprecated please use @website/ui instead
 */
export * from "./cta";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./cta.types";
